/**
 * DBT-053 (decisione di Vale del 13/10) — cosa manca per emettere una bozza.
 * L'elenco arriva dal server (`mancanti_per_emettere`, calcolato dal modello):
 * qui c'è solo il testo, così la regola non si ripete nel browser.
 */
export function mancantiPerEmettere(fattura) {
  if (!fattura || fattura.stato !== 'bozza') return [];
  return Array.isArray(fattura.mancanti_per_emettere) ? fattura.mancanti_per_emettere : [];
}

export function testoCosaManca(mancanti) {
  if (!mancanti || mancanti.length === 0) return '';
  return 'Per emettere la fattura manca: ' + mancanti.join(', ') + '.';
}
